module.exports = __webpack_public_path__ + "static/media/create-default.efc0c318.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/create-default.svg
// module id = 421
// module chunks = 0